/**
 * Formate un prix en FCFA (Franc CFA) avec séparateur de milliers.
 * Exemples :
 *   1200  -> "1 200 FCFA"
 *   16500 -> "16 500 FCFA"
 *   2100000 -> "2 100 000 FCFA"
 */
export function formatPrice(value: number): string {
  const formatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
  return `${formatted} FCFA`;
}

/**
 * Format compact pour les prix élevés (K, M).
 */
export function formatPriceCompact(value: number): string {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1).replace(".", ",")} M FCFA`;
  }
  if (value >= 1000) {
    return `${Math.round(value / 1000)} K FCFA`;
  }
  return formatPrice(value);
}
